import React from "react";
import { User } from "lucide-react";
import { PROFILE } from "../data/content";

// Clipped architectural portrait frame. Renders the headshot when PROFILE.headshot
// is set (with a subtle faded, on-brand treatment); otherwise a placeholder.
export const Headshot = ({ className = "", testid = "headshot", eager = false }) => {
  const clip = "[clip-path:polygon(0_0,100%_0,100%_92%,88%_100%,0_100%)]";
  const hasPhoto = Boolean(PROFILE.headshot);

  return (
    <div
      data-testid={testid}
      className={`relative overflow-hidden border border-[#16281C]/12 ${clip} ${className} ${
        hasPhoto ? "bg-gradient-to-b from-[#DEE5D6] to-[#C4D3C0]" : "bg-[#DDE4D5]"
      }`}
    >
      {hasPhoto ? (
        <>
          <img
            src={PROFILE.headshot}
            alt={`${PROFILE.name} — ${PROFILE.title}`}
            loading={eager ? "eager" : "lazy"}
            className="w-full h-full object-cover object-top opacity-90 [filter:grayscale(0.22)_contrast(0.95)_brightness(1.02)]"
          />
          {/* faded on-brand wash */}
          <div className="absolute inset-0 bg-gradient-to-t from-[#2C5F3A]/35 via-transparent to-[#EFEBDE]/25 mix-blend-multiply pointer-events-none" />
          <div className="absolute inset-0 bg-[#EFEBDE]/12 pointer-events-none" />
          <span className="absolute top-4 left-4 font-mono text-[10px] tracking-[0.2em] uppercase text-[#16281C]/70 [text-shadow:0_1px_2px_rgba(239,235,222,0.6)]">
            AC / 2026
          </span>
        </>
      ) : (
        <>
          <div className="w-full h-full flex flex-col items-center justify-center bg-gradient-to-br from-[#2C5F3A] via-[#244E30] to-[#16281C] p-6 text-center">
            <div className="w-20 h-20 rounded-full border border-[#EFEBDE]/40 flex items-center justify-center">
              <User size={34} className="text-[#EFEBDE]/70" strokeWidth={1.25} />
            </div>
            <span className="mt-6 font-display font-bold text-5xl tracking-tight text-[#EFEBDE]">AC</span>
            <span className="mt-4 font-mono text-[10px] tracking-[0.2em] uppercase text-[#EFEBDE]/60 leading-relaxed">
              Portrait placeholder<br />Send your headshot to swap
            </span>
          </div>
          <span className="absolute top-4 left-4 font-mono text-[10px] tracking-[0.2em] uppercase text-[#EFEBDE]/80">
            AC / 2026
          </span>
        </>
      )}
    </div>
  );
};
